"use client";

import { FC } from "react";
import { useRouter } from "next/navigation";
import { MdEdit } from "react-icons/md";

import { useAppDispatch } from "@/redux/store";
import { setRoomUUID, setGenerations, resetRoom } from "@/redux/actions";
import Button from "@/components/common/PrimaryButton";

interface UsePromptProps {
  prompt: string;
}

const UsePrompt: FC<UsePromptProps> = ({ prompt }) => {
  const router = useRouter();
  const dispatch = useAppDispatch();

  const handleUsePrompt = () => {
    dispatch(setRoomUUID(null));
    dispatch(setGenerations([]));
    dispatch(resetRoom());
    router.push(`/idea/?prompt=${prompt}`);
  };

  if (!prompt) return null;

  return (
    <Button
      variant="outlined"
      size="small"
      color="secondary"
      onClick={handleUsePrompt}
      aria-label="Use prompt"
      icon={<MdEdit />}
    >
      Use
    </Button>
  );
};

export default UsePrompt;
